// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
#AdminUserChatLog {
  /* チャットログ一覧: 質問 / 質問補強セル */
  /* 分析設定ポップアップ */
  /* よくある質問分析モーダル */
}
#AdminUserChatLog .margin-bottom-16px {
  margin-bottom: 16px;
}
#AdminUserChatLog .dl-button {
  width: 180px;
}
#AdminUserChatLog .date-radio-area {
  position: relative;
  z-index: var(--z-index-local-over-3);
}
#AdminUserChatLog .calender-dialog {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  padding: 8px;
  background-color: transparent;
  z-index: var(--z-index-local-over-2);
}
#AdminUserChatLog .wordcloud-area {
  height: 480px;
  width: 100%;
  min-height: 280px;
}
#AdminUserChatLog .ranking-area {
  height: 480px;
  min-width: 240px;
}
#AdminUserChatLog .graph-element {
  background-color: var(--primary-color-main);
  width: 0%;
  height: 18px;
  transition: width 0.3s;
}
#AdminUserChatLog .search-input-area {
  overflow: hidden;
}
#AdminUserChatLog .search-input-area .textinput {
  border: none;
}
#AdminUserChatLog .search-input-area .tag-input {
  min-width: 280px;
}
#AdminUserChatLog .search-input-area .tag-input .textinput {
  border: none;
  padding-right: 48px;
}
#AdminUserChatLog .search-input-area .search-button {
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  right: 0;
  width: 40px;
  height: 40px;
  border-left: solid 1px var(--border-color);
  border-radius: 0;
  background-color: var(--white-color-lightest);
  color: var(--font_active_sub_color);
}
#AdminUserChatLog .search-input-area .search-button:hover {
  background-color: var(--white-color-main);
}
#AdminUserChatLog .search-input-area .filter-label {
  display: flex;
  align-items: center;
  background-color: var(--primary-color-lightest);
  border: 1px solid var(--border-weak-color);
  border-radius: 24px;
  padding: 4px 12px;
  font-size: 12px;
  white-space: nowrap;
  height: 24px;
  box-sizing: border-box;
}
#AdminUserChatLog .search-input-area .filter-label .filter-label-text {
  margin-right: 8px;
}
#AdminUserChatLog .search-input-area .filter-label .filter-label-close {
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}
#AdminUserChatLog .search-input-area .filter-label .filter-label-close:hover {
  opacity: 0.7;
}
#AdminUserChatLog .search-input-area .filter-button {
  width: fit-content;
}
#AdminUserChatLog .chatlog-question-cell {
  align-items: flex-start;
  width: 100%;
}
#AdminUserChatLog .chatlog-question-text {
  width: 100%;
  word-break: break-word;
  overflow-wrap: anywhere;
}
#AdminUserChatLog .chatlog-adjust-question {
  width: 100%;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px dashed var(--border-weak-color);
  color: var(--font_inactive_color);
  font-size: 12px;
  line-height: 1.5;
  word-break: break-word;
  overflow-wrap: anywhere;
}
#AdminUserChatLog .analytics-area {
  transition: min-height 0.5s max-height 0.5s;
  max-height: fit-content;
  min-height: fit-content;
}
#AdminUserChatLog .analytics-area .analytics-area-row {
  transition: min-height 0.5s max-height 0.5s;
  overflow: hidden;
  max-height: fit-content;
  min-height: fit-content;
  position: relative;
}
#AdminUserChatLog .analytics-area .analytics-area-row .analytics-loading {
  background-color: var(--white-color-lightest);
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 480px;
  z-index: var(--z-index-local-over-1);
}
#AdminUserChatLog .analytics-area .analytics-area-row .analytics-loading .loader {
  font-size: 48px;
  color: var(--dark-color-light);
}
#AdminUserChatLog .analytics-area .analytics-area-row .empty-info {
  background-color: var(--white-color-lightest);
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 480px;
  z-index: var(--z-index-local-over-2);
}
#AdminUserChatLog .analytics-area .analytics-area-row .empty-info .info-card {
  width: 35vw;
}
#AdminUserChatLog .scroll-button {
  position: fixed;
  bottom: 16px;
  right: 16px;
  width: 64px;
  height: 64px;
  z-index: var(--z-index-local-over-5);
}
#AdminUserChatLog .filter-drawer-overlay {
  position: fixed;
  margin-top: 0;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: none;
}
#AdminUserChatLog .filter-drawer-overlay.show {
  display: block;
  transition: background-color 0.3s ease-in-out;
}
#AdminUserChatLog .filter-drawer {
  position: fixed;
  margin-top: 0;
  top: 0;
  right: -520px;
  width: 520px;
  height: 100vh;
  background-color: white;
  z-index: 1001;
  transition: right 0.3s ease-in-out;
  padding: 16px;
  box-shadow: -4px 0 16px rgba(0, 0, 0, 0.1);
}
#AdminUserChatLog .filter-drawer.show {
  right: 0;
}
#AdminUserChatLog .faq-analysis-button {
  min-width: 220px;
}
#AdminUserChatLog .faq-config-modal {
  height: auto;
  max-height: 600px;
}
#AdminUserChatLog .modal-body.faq-config-body {
  background-color: #f5f7fa;
  overflow: visible;
}
#AdminUserChatLog .faq-config-card {
  background: #ffffff;
  padding: 24px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow: visible;
}
#AdminUserChatLog .faq-config-radio-area .calender-dialog {
  z-index: 10000;
}
#AdminUserChatLog .faq-config-top-row {
  flex-wrap: wrap;
  gap: 16px;
}
#AdminUserChatLog .faq-config-radio-area {
  position: relative;
}
#AdminUserChatLog .faq-config-count-area {
  min-width: 280px;
}
#AdminUserChatLog .modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}
#AdminUserChatLog .modal-overlay .background-gray {
  background-color: #f9f9f9;
  padding: 8px 16px;
}
#AdminUserChatLog .modal-content {
  background: #fff;
  width: 90%;
  max-width: 1000px;
  height: auto;
  max-height: 90vh;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
#AdminUserChatLog .modal-header {
  min-height: 64px;
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e0e0e0;
}
#AdminUserChatLog .modal-header .text-size-h2 {
  font-weight: 600;
  font-size: 1.25rem;
}
#AdminUserChatLog .modal-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 24px;
  background-color: #f9f9f9;
}
#AdminUserChatLog .modal-body .markdown-content {
  background: #fff;
  padding: 24px;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  line-height: 1.7;
  white-space: pre-wrap;
  word-break: break-word;
}
#AdminUserChatLog .modal-footer {
  min-height: 64px;
  padding: 12px 24px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
}
#AdminUserChatLog .faq-generating {
  flex: 1 1;
  padding: 48px 24px;
}
#AdminUserChatLog .faq-loading-badge {
  width: 88px;
  height: 88px;
  border-radius: 50%;
  background-color: var(--primary-color-main, #1F3A5F);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}
#AdminUserChatLog .faq-loading-badge .loading-box {
  --base-size: 40px;
}
#AdminUserChatLog .faq-body {
  background-color: #f5f7fa;
}
#AdminUserChatLog .faq-card {
  background: #ffffff;
  border-radius: 8px;
  padding: 20px 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  border-left: 4px solid var(--primary-color-main, #1F3A5F);
  display: flex;
  flex-direction: column;
  gap: 12px;
}
#AdminUserChatLog .faq-card-meta {
  flex-wrap: wrap;
  gap: 8px;
}
#AdminUserChatLog .faq-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
}
#AdminUserChatLog .faq-badge-category {
  background: #E8EEF7;
  color: #1F3A5F;
  border: 1px solid #c8d4e6;
}
#AdminUserChatLog .faq-badge-frequency {
  border: 1px solid transparent;
}
#AdminUserChatLog .faq-badge-frequency.level-高 {
  background: #fde2e2;
  color: #b53737;
  border-color: #f1b3b3;
}
#AdminUserChatLog .faq-badge-frequency.level-中 {
  background: #fff3d4;
  color: #8a6a16;
  border-color: #f0d99a;
}
#AdminUserChatLog .faq-badge-frequency.level-低 {
  background: #e3f0e0;
  color: #3f7a3a;
  border-color: #b9d7b4;
}
#AdminUserChatLog .faq-card-question,
#AdminUserChatLog .faq-card-answer {
  width: 100%;
  align-items: flex-start;
  gap: 12px;
}
#AdminUserChatLog .faq-marker {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  flex-shrink: 0;
}
#AdminUserChatLog .faq-marker.question {
  background: #1F3A5F;
  color: #ffffff;
}
#AdminUserChatLog .faq-marker.answer {
  background: #e8eef7;
  color: #1F3A5F;
  border: 1px solid #c8d4e6;
}
#AdminUserChatLog .faq-card-question-text {
  font-size: 15px;
  font-weight: 700;
  color: #1F3A5F;
  line-height: 1.5;
  padding-top: 3px;
  word-break: break-word;
}
#AdminUserChatLog .faq-card-answer-text {
  font-size: 14px;
  color: #333333;
  line-height: 1.7;
  padding-top: 4px;
  white-space: pre-wrap;
  word-break: break-word;
}`, "",{"version":3,"sources":["webpack://./src/components/admin/parts/AdminUserChatLog.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EAoHI,0BAAA;EAyHA,eAAA;EAsCA,iBAAA;AA9QJ;AAAI;EACI,mBAAA;AAER;AAAI;EACI,YAAA;AAER;AAAI;EACI,kBAAA;EACA,oCAAA;AAER;AACI;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,eAAA;EACA,YAAA;EACA,6BAAA;EACA,oCAAA;AACR;AAEI;EACI,aAAA;EACA,WAAA;EACA,iBAAA;AAAR;AAEI;EACI,aAAA;EACA,gBAAA;AAAR;AAGI;EACI,2CAAA;EACA,SAAA;EACA,YAAA;EACA,sBAAA;AADR;AAII;EACI,gBAAA;AAFR;AAIQ;EACI,YAAA;AAFZ;AAKQ;EACI,gBAAA;AAHZ;AAKY;EACI,YAAA;EACA,mBAAA;AAHhB;AAOQ;EACI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,QAAA;EAEA,WAAA;EACA,YAAA;EAEA,0CAAA;EAEA,gBAAA;EACA,6CAAA;EACA,mCAAA;AARZ;AAUY;EACI,yCAAA;AARhB;AAYQ;EACI,aAAA;EACA,mBAAA;EACA,+CAAA;EACA,0CAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;AAVZ;AAYY;EACI,iBAAA;AAVhB;AAaY;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;AAXhB;AAagB;EACI,YAAA;AAXpB;AAgBQ;EACI,kBAAA;AAdZ;AAmBI;EACI,uBAAA;EACA,WAAA;AAjBR;AAoBI;EACI,WAAA;EACA,sBAAA;EACA,uBAAA;AAlBR;AAqBI;EACI,WAAA;EACA,eAAA;EACA,gBAAA;EACA,+CAAA;EACA,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,uBAAA;AAnBR;AAsBI;EACI,2CAAA;EACA,uBAAA;EACA,uBAAA;AApBR;AAsBQ;EACI,2CAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;AApBZ;AAsBY;EACI,6CAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,oCAAA;AApBhB;AAsBgB;EACI,eAAA;EACA,8BAAA;AApBpB;AAwBY;EACI,6CAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,oCAAA;AAtBhB;AAwBgB;EACI,WAAA;AAtBpB;AA4BI;EACI,eAAA;EACA,YAAA;EACA,WAAA;EAEA,WAAA;EACA,YAAA;EAEA,oCAAA;AA5BR;AA+BI;EACI,eAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,oCAAA;EACA,aAAA;EACA,aAAA;AA7BR;AA+BQ;EACI,cAAA;EACA,6CAAA;AA7BZ;AAiCI;EACI,eAAA;EACA,aAAA;EACA,MAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,aAAA;EACA,kCAAA;EACA,aAAA;EACA,0CAAA;AA/BR;AAiCQ;EACI,QAAA;AA/BZ;AAmCI;EACI,gBAAA;AAjCR;AAqCI;EACI,YAAA;EACA,iBAAA;AAnCR;AAsCI;EACI,yBAAA;EACA,iBAAA;AApCR;AAuCI;EACI,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;AArCR;AAwCI;EACI,cAAA;AAtCR;AAyCI;EACI,eAAA;EACA,SAAA;AAvCR;AA0CI;EACI,kBAAA;AAxCR;AA2CI;EACI,gBAAA;AAzCR;AA6CI;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,oCAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA3CR;AA6CQ;EACI,yBAAA;EACA,iBAAA;AA3CZ;AA+CI;EACI,gBAAA;EACA,UAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,0CAAA;AA7CR;AAgDI;EACI,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gCAAA;AA9CR;AAgDQ;EACI,gBAAA;EACA,kBAAA;AA9CZ;AAkDI;EACI,SAAA;EACA,gBAAA;EACA,aAAA;EACA,yBAAA;AAhDR;AAkDQ;EACI,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,wCAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;AAhDZ;AAoDI;EACI,gBAAA;EACA,kBAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;AAlDR;AAqDI;EACI,SAAA;EACA,kBAAA;AAnDR;AAsDI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oDAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AApDR;AAsDQ;EACI,iBAAA;AApDZ;AAwDI;EACI,yBAAA;AAtDR;AAyDI;EACI,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yCAAA;EACA,yDAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAvDR;AA0DI;EACI,eAAA;EACA,QAAA;AAxDR;AA2DI;EACI,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAzDR;AA4DI;EACI,mBAAA;EACA,cAAA;EACA,yBAAA;AA1DR;AA6DI;EACI,6BAAA;AA3DR;AA6DQ;EACI,mBAAA;EACA,cAAA;EACA,qBAAA;AA3DZ;AA6DQ;EACI,mBAAA;EACA,cAAA;EACA,qBAAA;AA3DZ;AA6DQ;EACI,mBAAA;EACA,cAAA;EACA,qBAAA;AA3DZ;AA+DI;;EAEI,WAAA;EACA,uBAAA;EACA,SAAA;AA7DR;AAgEI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA9DR;AAgEQ;EACI,mBAAA;EACA,cAAA;AA9DZ;AAgEQ;EACI,mBAAA;EACA,cAAA;EACA,yBAAA;AA9DZ;AAkEI;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;AAhER;AAmEI;EACI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;AAjER","sourcesContent":["#AdminUserChatLog{\r\n    .data-radio-stack{\r\n        // margin: 0px 0px  16px 0px;\r\n        // padding: 0px 0px 0px 40px;\r\n    }\r\n    .margin-bottom-16px {\r\n        margin-bottom: 16px;\r\n    }\r\n    .dl-button{\r\n        width: 180px;\r\n    }\r\n    .date-radio-area {\r\n        position: relative;\r\n        z-index: var(--z-index-local-over-3);\r\n    }\r\n\r\n    .calender-dialog{\r\n        position: absolute;\r\n        top: 100%;\r\n        right: 0;\r\n        margin-top: 8px;\r\n        padding: 8px;\r\n        background-color: transparent;\r\n        z-index: var(--z-index-local-over-2);\r\n    }\r\n\r\n    .wordcloud-area{\r\n        height: 480px;\r\n        width: 100%;\r\n        min-height: 280px;\r\n    }\r\n    .ranking-area{\r\n        height: 480px;\r\n        min-width: 240px;\r\n    }\r\n\r\n    .graph-element{\r\n        background-color: var(--primary-color-main);\r\n        width: 0%;\r\n        height: 18px;\r\n        transition: width 0.3s;\r\n    }\r\n\r\n    .search-input-area {\r\n        overflow: hidden;\r\n\r\n        .textinput {\r\n            border: none;\r\n        }\r\n\r\n        .tag-input {\r\n            min-width: 280px;\r\n\r\n            .textinput {\r\n                border: none;\r\n                padding-right: 48px;\r\n            }\r\n        }\r\n\r\n        .search-button {\r\n            position: absolute;\r\n            top: 0;\r\n            bottom: 0;\r\n            margin: auto;\r\n            right: 0;\r\n\r\n            width: 40px;\r\n            height: 40px;\r\n\r\n            border-left: solid 1px var(--border-color);\r\n\r\n            border-radius: 0;\r\n            background-color: var(--white-color-lightest);\r\n            color: var(--font_active_sub_color);\r\n\r\n            &:hover {\r\n                background-color: var(--white-color-main);\r\n            }\r\n        }\r\n\r\n        .filter-label {\r\n            display: flex;\r\n            align-items: center;\r\n            background-color: var(--primary-color-lightest);\r\n            border: 1px solid var(--border-weak-color);\r\n            border-radius: 24px;\r\n            padding: 4px 12px;\r\n            font-size: 12px;\r\n            white-space: nowrap;\r\n            height: 24px;\r\n            box-sizing: border-box;\r\n\r\n            .filter-label-text {\r\n                margin-right: 8px;\r\n            }\r\n\r\n            .filter-label-close {\r\n                display: flex;\r\n                align-items: center;\r\n                justify-content: center;\r\n                background: none;\r\n                border: none;\r\n                cursor: pointer;\r\n                padding: 0;\r\n                \r\n                &:hover {\r\n                    opacity: 0.7;\r\n                }\r\n            }\r\n        }\r\n\r\n        .filter-button {\r\n            width: fit-content;\r\n        }\r\n    }\r\n\r\n    /* チャットログ一覧: 質問 / 質問補強セル */\r\n    .chatlog-question-cell {\r\n        align-items: flex-start;\r\n        width: 100%;\r\n    }\r\n\r\n    .chatlog-question-text {\r\n        width: 100%;\r\n        word-break: break-word;\r\n        overflow-wrap: anywhere;\r\n    }\r\n\r\n    .chatlog-adjust-question {\r\n        width: 100%;\r\n        margin-top: 8px;\r\n        padding-top: 8px;\r\n        border-top: 1px dashed var(--border-weak-color);\r\n        color: var(--font_inactive_color);\r\n        font-size: 12px;\r\n        line-height: 1.5;\r\n        word-break: break-word;\r\n        overflow-wrap: anywhere;\r\n    }\r\n\r\n    .analytics-area{\r\n        transition: min-height 0.5s max-height 0.5s;\r\n        max-height: fit-content;\r\n        min-height: fit-content;\r\n\r\n        .analytics-area-row{\r\n            transition: min-height 0.5s max-height 0.5s;\r\n            overflow: hidden;\r\n            max-height: fit-content;\r\n            min-height: fit-content;\r\n            position: relative;\r\n\r\n            .analytics-loading {\r\n                background-color: var(--white-color-lightest);\r\n                position: absolute;\r\n                top: 0;\r\n                bottom: 0;\r\n                left: 0;\r\n                right: 0;\r\n                width: 100%;\r\n                height: 480px;\r\n                z-index: var(--z-index-local-over-1);\r\n\r\n                .loader {\r\n                    font-size: 48px;\r\n                    color: var(--dark-color-light);\r\n                }\r\n            }\r\n\r\n            .empty-info{\r\n                background-color: var(--white-color-lightest);\r\n                position: absolute;\r\n                top: 0;\r\n                bottom: 0;\r\n                left: 0;\r\n                right: 0;\r\n                width: 100%;\r\n                height: 480px;\r\n                z-index: var(--z-index-local-over-2);\r\n\r\n                .info-card{\r\n                    width: 35vw;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .scroll-button{\r\n        position: fixed;\r\n        bottom: 16px;\r\n        right: 16px;\r\n\r\n        width: 64px;\r\n        height: 64px;\r\n\r\n        z-index: var(--z-index-local-over-5);\r\n    }\r\n    \r\n    .filter-drawer-overlay {\r\n        position: fixed;\r\n        margin-top: 0;\r\n        top: 0;\r\n        left: 0;\r\n        width: 100vw;\r\n        height: 100vh;\r\n        background-color: rgba(0, 0, 0, 0.5);\r\n        z-index: 1000;\r\n        display: none;\r\n        \r\n        &.show {\r\n            display: block;\r\n            transition: background-color 0.3s ease-in-out;\r\n        }\r\n    }\r\n\r\n    .filter-drawer {\r\n        position: fixed;\r\n        margin-top: 0;\r\n        top: 0;\r\n        right: -520px;\r\n        width: 520px;\r\n        height: 100vh;\r\n        background-color: white;\r\n        z-index: 1001;\r\n        transition: right 0.3s ease-in-out;\r\n        padding: 16px;\r\n        box-shadow: -4px 0 16px rgba(0,0,0,0.1);\r\n\r\n        &.show {\r\n            right: 0;\r\n        }\r\n    }\r\n\r\n    .faq-analysis-button {\r\n        min-width: 220px;\r\n    }\r\n\r\n    /* 分析設定ポップアップ */\r\n    .faq-config-modal {\r\n        height: auto;\r\n        max-height: 600px;\r\n    }\r\n\r\n    .modal-body.faq-config-body {\r\n        background-color: #f5f7fa;\r\n        overflow: visible;\r\n    }\r\n\r\n    .faq-config-card {\r\n        background: #ffffff;\r\n        padding: 24px;\r\n        border-radius: 8px;\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: 16px;\r\n        overflow: visible;\r\n    }\r\n\r\n    .faq-config-radio-area .calender-dialog {\r\n        z-index: 10000;\r\n    }\r\n\r\n    .faq-config-top-row {\r\n        flex-wrap: wrap;\r\n        gap: 16px;\r\n    }\r\n\r\n    .faq-config-radio-area {\r\n        position: relative;\r\n    }\r\n\r\n    .faq-config-count-area {\r\n        min-width: 280px;\r\n    }\r\n\r\n    /* よくある質問分析モーダル */\r\n    .modal-overlay {\r\n        position: fixed;\r\n        top: 0;\r\n        left: 0;\r\n        width: 100vw;\r\n        height: 100vh;\r\n        background-color: rgba(0, 0, 0, 0.5);\r\n        z-index: 9999;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n\r\n        .background-gray {\r\n            background-color: #f9f9f9;\r\n            padding: 8px 16px;\r\n        }\r\n    }\r\n\r\n    .modal-content {\r\n        background: #fff;\r\n        width: 90%;\r\n        max-width: 1000px;\r\n        height: auto;\r\n        max-height: 90vh;\r\n        border-radius: 8px;\r\n        display: flex;\r\n        flex-direction: column;\r\n        box-shadow: 0 4px 12px rgba(0,0,0,0.15);\r\n    }\r\n\r\n    .modal-header {\r\n        min-height: 64px;\r\n        padding: 16px 24px;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: space-between;\r\n        border-bottom: 1px solid #e0e0e0;\r\n\r\n        .text-size-h2 {\r\n            font-weight: 600;\r\n            font-size: 1.25rem;\r\n        }\r\n    }\r\n\r\n    .modal-body {\r\n        flex: 1;\r\n        overflow-y: auto;\r\n        padding: 24px;\r\n        background-color: #f9f9f9;\r\n\r\n        .markdown-content {\r\n            background: #fff;\r\n            padding: 24px;\r\n            border-radius: 4px;\r\n            box-shadow: 0 1px 3px rgba(0,0,0,0.1);\r\n            line-height: 1.7;\r\n            white-space: pre-wrap;\r\n            word-break: break-word;\r\n        }\r\n    }\r\n\r\n    .modal-footer {\r\n        min-height: 64px;\r\n        padding: 12px 24px;\r\n        border-top: 1px solid #e0e0e0;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: flex-end;\r\n        gap: 16px;\r\n    }\r\n\r\n    .faq-generating {\r\n        flex: 1;\r\n        padding: 48px 24px;\r\n    }\r\n\r\n    .faq-loading-badge {\r\n        width: 88px;\r\n        height: 88px;\r\n        border-radius: 50%;\r\n        background-color: var(--primary-color-main, #1F3A5F);\r\n        color: #ffffff;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n\r\n        .loading-box {\r\n            --base-size: 40px;\r\n        }\r\n    }\r\n\r\n    .faq-body {\r\n        background-color: #f5f7fa;\r\n    }\r\n\r\n    .faq-card {\r\n        background: #ffffff;\r\n        border-radius: 8px;\r\n        padding: 20px 24px;\r\n        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\r\n        border-left: 4px solid var(--primary-color-main, #1F3A5F);\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: 12px;\r\n    }\r\n\r\n    .faq-card-meta {\r\n        flex-wrap: wrap;\r\n        gap: 8px;\r\n    }\r\n\r\n    .faq-badge {\r\n        display: inline-flex;\r\n        align-items: center;\r\n        padding: 4px 10px;\r\n        border-radius: 999px;\r\n        font-size: 12px;\r\n        font-weight: 600;\r\n        line-height: 1.4;\r\n    }\r\n\r\n    .faq-badge-category {\r\n        background: #E8EEF7;\r\n        color: #1F3A5F;\r\n        border: 1px solid #c8d4e6;\r\n    }\r\n\r\n    .faq-badge-frequency {\r\n        border: 1px solid transparent;\r\n\r\n        &.level-高 {\r\n            background: #fde2e2;\r\n            color: #b53737;\r\n            border-color: #f1b3b3;\r\n        }\r\n        &.level-中 {\r\n            background: #fff3d4;\r\n            color: #8a6a16;\r\n            border-color: #f0d99a;\r\n        }\r\n        &.level-低 {\r\n            background: #e3f0e0;\r\n            color: #3f7a3a;\r\n            border-color: #b9d7b4;\r\n        }\r\n    }\r\n\r\n    .faq-card-question,\r\n    .faq-card-answer {\r\n        width: 100%;\r\n        align-items: flex-start;\r\n        gap: 12px;\r\n    }\r\n\r\n    .faq-marker {\r\n        width: 28px;\r\n        height: 28px;\r\n        border-radius: 50%;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        font-size: 13px;\r\n        font-weight: 700;\r\n        flex-shrink: 0;\r\n\r\n        &.question {\r\n            background: #1F3A5F;\r\n            color: #ffffff;\r\n        }\r\n        &.answer {\r\n            background: #e8eef7;\r\n            color: #1F3A5F;\r\n            border: 1px solid #c8d4e6;\r\n        }\r\n    }\r\n\r\n    .faq-card-question-text {\r\n        font-size: 15px;\r\n        font-weight: 700;\r\n        color: #1F3A5F;\r\n        line-height: 1.5;\r\n        padding-top: 3px;\r\n        word-break: break-word;\r\n    }\r\n\r\n    .faq-card-answer-text {\r\n        font-size: 14px;\r\n        color: #333333;\r\n        line-height: 1.7;\r\n        padding-top: 4px;\r\n        white-space: pre-wrap;\r\n        word-break: break-word;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
